import React from 'react';

import { cn } from 'helpers/classnames';

import css from 'styles/containers/returns/returnInstructionsBoxes.scss';

const ReturnInstructionsBox = ({ children, image, title }) => (
  <div className={css.box}>
    <p className={cn(css.heading, 'zappos:body-xs-bold')}>{title}</p>
    <div className={css.content}>
      <div className={css.illustration}>
        <img src={image} alt="" />
      </div>
      <div className={cn(css.instructions, 'zappos:body-xs')}>{children}</div>
    </div>
  </div>
);

export default ReturnInstructionsBox;
